export class Interval
{

    intervalId: number;
}
